var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntelligentBasket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1050 522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .ib_cls-1 {\n        clip-path: url(#clip-ib-container);\n      }\n\n      .ib_cls-2 {\n        fill: #c4ae70;\n      }\n\n      .ib_cls-10,\n      .ib_cls-3,\n      .ib_cls-5,\n      .ib_cls-7 {\n        opacity: 0.2;\n      }\n\n      .ib_cls-10,\n      .ib_cls-12,\n      .ib_cls-16,\n      .ib_cls-17,\n      .ib_cls-29,\n      .ib_cls-39,\n      .ib_cls-6,\n      .ib_cls-9 {\n        fill: #fff;\n      }\n\n      .ib_cls-4 {\n        fill: transparent;\n      }\n\n      .ib_cls-6 {\n        opacity: 0.6;\n      }\n\n      .ib_cls-7,\n      .ib_cls-8 {\n        fill: #263238;\n      }\n\n      .ib_cls-15,\n      .ib_cls-37,\n      .ib_cls-9 {\n        opacity: 0.3;\n      }\n\n      .ib_cls-11 {\n        opacity: 0.8;\n      }\n\n      .ib_cls-12 {\n        opacity: 0.7;\n      }\n\n      .ib_cls-13 {\n        fill: #407bff;\n      }\n\n      .ib_cls-14,\n      .ib_cls-16 {\n        opacity: 0.4;\n      }\n\n      .ib_cls-17 {\n        opacity: 0.5;\n      }\n\n      .ib_cls-18 {\n        fill: #242737;\n      }\n\n      .ib_cls-19 {\n        fill: #d4e0e9;\n      }\n\n      .ib_cls-20 {\n        fill: #717e83;\n      }\n\n      .ib_cls-21 {\n        fill: #9cadb5;\n      }\n\n      .ib_cls-22 {\n        fill: #ebebeb;\n      }\n\n      .ib_cls-23 {\n        fill: #dbdbdb;\n      }\n\n      .ib_cls-24 {\n        fill: #c7c7c7;\n      }\n\n      .ib_cls-25 {\n        fill: #ffc727;\n      }\n\n      .ib_cls-26,\n      .ib_cls-27,\n      .ib_cls-39 {\n        opacity: 0.1;\n      }\n\n      .ib_cls-28 {\n        fill: #c93;\n      }\n\n      .ib_cls-29,\n      .ib_cls-31 {\n        stroke: #ebebeb;\n        stroke-miterlimit: 10;\n      }\n\n      .ib_cls-30 {\n        fill: #b7b7b7;\n      }\n\n      .ib_cls-31,\n      .ib_cls-33,\n      .ib_cls-35 {\n        fill: none;\n      }\n\n      .ib_cls-32 {\n        fill: #adadad;\n      }\n\n      .ib_cls-33,\n      .ib_cls-34,\n      .ib_cls-35 {\n        stroke: #263238;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .ib_cls-33 {\n        stroke-width: 2px;\n      }\n\n      .ib_cls-34 {\n        fill: #043d82;\n      }\n\n      .ib_cls-35 {\n        stroke-width: 3px;\n      }\n\n      .ib_cls-36 {\n        fill: #81ddbf;\n      }\n\n      .ib_cls-38 {\n        opacity: 0.07;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ib-container",
    "data-name": "ib container",
    className: "ib_cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ib_cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "coin-basket",
    "data-name": "Group 102",
    transform: "translate(735.772 273.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(76.19 70.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_9KWdk1",
    "data-name": "9KWdk1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "ib_cls-22",
    d: "M971.183,424.673a40.992,40.992,0,1,1-31.206-48.952A41,41,0,0,1,971.183,424.673Z",
    transform: "translate(-890.166 -374.754)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(2.929 2.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "ib_cls-23",
    d: "M922.838,452.744a38.063,38.063,0,1,1,45.291-28.9A38.038,38.038,0,0,1,922.838,452.744Zm41.343-29.153a34.162,34.162,0,1,0-41.551,25.093A34.183,34.183,0,0,0,964.181,423.591Z",
    transform: "translate(-892.9 -377.488)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "ib_cls-23",
    d: "M934.756,391.221l3.826.837-.24,1.1c-.327,1.491-.631,2.988-.989,4.472-.134.553.035.728.556.927a29.731,29.731,0,0,1,4.506,1.927c3.621,2.118,4.857,5.475,3.668,9.5a17.7,17.7,0,0,1-.762,2.156,6.027,6.027,0,0,1-4.137,3.408c-.44.123-.887.229-1.416.366.572.4,1.092.732,1.574,1.112a8.166,8.166,0,0,1,3.124,8.489,11.963,11.963,0,0,1-1.646,4.462,7.852,7.852,0,0,1-5.108,3.474,18.722,18.722,0,0,1-7.364-.1c-.575-.1-.816-.019-.937.6-.287,1.474-.668,2.931-.987,4.4-.079.363-.224.545-.6.464-1.06-.229-2.119-.462-3.284-.717l.3-1.379c.272-1.244.529-2.49.822-3.728.1-.424.029-.642-.437-.722-.722-.126-1.436-.305-2.226-.479l-1.236,5.657-3.836-.839c.41-1.88.813-3.722,1.234-5.649l-9.5-2.076c.476-2.178.932-4.267,1.406-6.436l2.808.613c1.614-7.39,3.211-14.7,4.823-22.074l-2.784-.607,1.4-6.412,9.455,2.067,1.367-6.26,3.806.831c-.444,2.031-.889,4.071-1.349,6.172l2.817.616C933.853,395.351,934.3,393.326,934.756,391.221Zm-6.188,25.853c-.632-.138-1.268-.257-1.894-.421-.411-.107-.581.024-.667.431-.545,2.553-1.1,5.1-1.675,7.65-.111.493.059.656.508.743,1.111.22,2.211.489,3.321.708a4.125,4.125,0,0,0,4.9-2.637,4.286,4.286,0,0,0-3.21-6.193Q929.212,417.213,928.568,417.074Zm-.392-9.9c-.237,1.084-.464,2.169-.716,3.25-.084.362-.014.568.38.643,1.158.219,2.305.5,3.47.668a2.577,2.577,0,0,0,2.861-1.6,8.817,8.817,0,0,0,.651-2.323,3.252,3.252,0,0,0-2.7-3.753c-.856-.194-1.721-.357-2.572-.57-.416-.1-.586.022-.668.427C928.661,405,928.414,406.085,928.176,407.169Z",
    transform: "translate(-891.705 -376.612)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "ib_cls-4",
    d: "M959.114,395.827a33.777,33.777,0,0,1,5.13,12.365,34.469,34.469,0,0,1-.11,13.466,33.883,33.883,0,0,1-5.342,12.409,34.2,34.2,0,0,1-22.35,14.3,33.851,33.851,0,0,1-13.506-.342,34.474,34.474,0,0,1-12.275-5.538,33.8,33.8,0,0,1-9.079-9.839A34.355,34.355,0,0,0,936.269,447.4a34.4,34.4,0,0,0,21.719-13.895,34.366,34.366,0,0,0,1.126-37.68Z",
    transform: "translate(-889.352 -373.251)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "ib_cls-24",
    d: "M901.755,433.623a33.8,33.8,0,0,1-5.092-12.381,34.469,34.469,0,0,1,.152-13.465,33.86,33.86,0,0,1,5.38-12.393,34.207,34.207,0,0,1,22.393-14.234,33.888,33.888,0,0,1,13.505.384,34.449,34.449,0,0,1,12.258,5.575,33.782,33.782,0,0,1,9.049,9.867,34.357,34.357,0,0,0-34.643-14.859A34.406,34.406,0,0,0,903,395.946a34.369,34.369,0,0,0-1.242,37.677Z",
    transform: "translate(-889.745 -374.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    className: "ib_cls-4",
    d: "M915.493,400.386c.084-.542.176-1.082.271-1.621s.182-1.079.288-1.616l.618-3.224.042-.221.23.046q4.744.953,9.454,2.068l-.27.172.766-3.111.4-1.551c.134-.517.272-1.034.419-1.548-.081.529-.17,1.055-.264,1.582l-.281,1.578-.6,3.148-.042.219-.229-.045q-4.745-.95-9.454-2.064l.272-.175-.783,3.187c-.128.532-.275,1.06-.412,1.59S915.643,399.859,915.493,400.386Z",
    transform: "translate(-888.36 -373.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    className: "ib_cls-4",
    d: "M909.657,428.145c.185-1.084.4-2.162.6-3.242s.424-2.155.634-3.233l.034-.175.18.036,2.818.566-.272.175,1.172-5.526c.39-1.842.82-3.675,1.228-5.513s.844-3.67,1.281-5.5.892-3.66,1.366-5.484c-.331,1.856-.673,3.708-1.047,5.554s-.729,3.695-1.13,5.535-.769,3.686-1.183,5.524l-1.24,5.511-.051.227-.222-.052-2.8-.661.214-.137c-.258,1.067-.5,2.138-.772,3.2S909.94,427.082,909.657,428.145Z",
    transform: "translate(-888.776 -372.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    className: "ib_cls-4",
    d: "M923.829,423.566c.624.074,1.24.182,1.86.272l1.847.326a3.994,3.994,0,0,0,3.242-1.024,4.794,4.794,0,0,0,1.433-3.163,4.518,4.518,0,0,0-.192-1.787,4.329,4.329,0,0,0-.868-1.617A4.348,4.348,0,0,1,932.626,420a4.875,4.875,0,0,1-1.483,3.541,4.188,4.188,0,0,1-3.693,1.032C926.235,424.261,925.027,423.941,923.829,423.566Z",
    transform: "translate(-887.766 -371.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    className: "ib_cls-4",
    d: "M926.763,410.09c1.022.11,2.065.28,3.05.439a3.092,3.092,0,0,0,2.516-1.095,4.487,4.487,0,0,0,1-2.684,5.082,5.082,0,0,0-.69-2.9,4.436,4.436,0,0,1,1.1,2.9,4.506,4.506,0,0,1-1.011,3.029,3.335,3.335,0,0,1-2.978,1.163C928.719,410.71,927.755,410.41,926.763,410.09Z",
    transform: "translate(-887.557 -372.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    className: "ib_cls-4",
    d: "M918.608,428.226a13.879,13.879,0,0,1-.354,2.882,13.712,13.712,0,0,1-.881,2.767,13.8,13.8,0,0,1,.354-2.882A13.945,13.945,0,0,1,918.608,428.226Z",
    transform: "translate(-888.226 -370.941)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    className: "ib_cls-4",
    d: "M924.633,429.617a13.728,13.728,0,0,1-.35,2.866,13.572,13.572,0,0,1-.876,2.75,15.469,15.469,0,0,1,1.227-5.616Z",
    transform: "translate(-887.796 -370.842)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(22.032 74.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_9KWdk1-2",
    "data-name": "9KWdk1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "ib_cls-25",
    d: "M916.337,417.857a38.362,38.362,0,1,1-38.309-38.52A38.374,38.374,0,0,1,916.337,417.857Z",
    transform: "translate(-839.614 -379.337)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    className: "ib_cls-26",
    transform: "translate(2.739 2.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M877.778,453.136a35.621,35.621,0,1,1,35.635-35.47A35.6,35.6,0,0,1,877.778,453.136Zm31.976-34.913a31.969,31.969,0,1,0-32.976,31.243A31.988,31.988,0,0,0,909.754,418.223Z",
    transform: "translate(-842.171 -381.895)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    className: "ib_cls-4",
    d: "M899.538,394.057a31.606,31.606,0,0,1,7.16,10.281,32.233,32.233,0,0,1,2.589,12.333,31.71,31.71,0,0,1-2.405,12.412,32.007,32.007,0,0,1-17.576,17.54,31.706,31.706,0,0,1-12.417,2.386,32.254,32.254,0,0,1-12.33-2.612,31.627,31.627,0,0,1-10.265-7.181,32.154,32.154,0,0,0,34.66,6.559,32.2,32.2,0,0,0,17.081-17.042,32.165,32.165,0,0,0-6.5-34.675Z",
    transform: "translate(-838.567 -378.287)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    className: "ib_cls-27",
    d: "M854.73,439.811a31.617,31.617,0,0,1-7.127-10.3,32.263,32.263,0,0,1-2.551-12.342,31.7,31.7,0,0,1,2.443-12.4,32.017,32.017,0,0,1,17.63-17.486,31.7,31.7,0,0,1,12.424-2.347,32.257,32.257,0,0,1,12.321,2.649,31.615,31.615,0,0,1,10.244,7.213,32.152,32.152,0,0,0-34.641-6.665,32.2,32.2,0,0,0-17.133,16.99,32.163,32.163,0,0,0,6.39,34.695Z",
    transform: "translate(-839.226 -378.939)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(13.34 14.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    className: "ib_cls-4",
    d: "M866.954,412.875l9.455-9.455,9.46,9.459,5.5-5.5-14.961-14.961-14.957,14.957,5.5,5.5m-14.888,3.886,5.5-5.5,5.5,5.5-5.5,5.5Zm14.888,3.886,9.455,9.454,9.46-9.46,5.5,5.5,0,0L876.409,441.1l-14.957-14.957-.008-.009,5.509-5.494m22.8-3.882,5.5-5.5,5.5,5.5-5.5,5.5Z",
    transform: "translate(-852.066 -392.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    className: "ib_cls-4",
    d: "M880.74,415.508h0l-5.582-5.583-4.127,4.125h0l-.474.475-.978.978-.007.007.007.007,5.578,5.579,5.583-5.583,0,0,0,0",
    transform: "translate(-850.817 -391.167)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2",
    transform: "translate(14.02 14.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    className: "ib_cls-28",
    d: "M867.589,412.876l9.455-9.455,9.46,9.459,5.5-5.5-14.961-14.961-14.957,14.957,5.5,5.5M852.7,416.76l5.5-5.5,5.5,5.5-5.5,5.5Zm14.888,3.885,9.455,9.455,9.46-9.46,5.5,5.5,0,0L877.044,441.1l-14.957-14.957-.008-.009,5.51-5.494m22.794-3.882,5.5-5.5,5.5,5.5-5.5,5.5Z",
    transform: "translate(-852.701 -392.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    className: "ib_cls-28",
    d: "M881.375,415.509h0l-5.583-5.583-4.126,4.125h0l-.475.475-.977.978-.009.008.009.008L875.8,421.1l5.583-5.583,0,0,0,0",
    transform: "translate(-851.452 -391.168)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_9KWdk1-3",
    "data-name": "9KWdk1",
    transform: "translate(136.328 67.681)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    className: "ib_cls-25",
    d: "M1025.173,429.229a40.992,40.992,0,1,1-22.252-53.617A41,41,0,0,1,1025.173,429.229Z",
    transform: "translate(-946.302 -372.506)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    className: "ib_cls-27",
    d: "M1025.173,429.229a40.992,40.992,0,1,1-22.252-53.617A41,41,0,0,1,1025.173,429.229Z",
    transform: "translate(-946.302 -372.506)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    className: "ib_cls-26",
    transform: "translate(2.929 2.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M972.659,448.53a38.063,38.063,0,1,1,49.615-20.616A38.04,38.04,0,0,1,972.659,448.53Zm45.77-21.549A34.162,34.162,0,1,0,973.158,444.5,34.183,34.183,0,0,0,1018.428,426.98Z",
    transform: "translate(-949.036 -375.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M995.03,390.19l3.623,1.486c-.152.373-.29.708-.427,1.045-.58,1.412-1.14,2.834-1.75,4.234-.226.521-.09.723.388,1.007a29.884,29.884,0,0,1,4.1,2.68c3.2,2.714,3.834,6.234,1.965,10a17.7,17.7,0,0,1-1.123,1.991,6.023,6.023,0,0,1-4.666,2.639c-.455.046-.914.073-1.459.116.494.495.949.911,1.357,1.368a8.166,8.166,0,0,1,1.607,8.9,11.974,11.974,0,0,1-2.394,4.108,7.852,7.852,0,0,1-5.633,2.538,18.74,18.74,0,0,1-7.236-1.37c-.55-.2-.8-.162-1.027.426-.539,1.4-1.167,2.77-1.733,4.162-.141.344-.316.5-.674.352-1-.409-2.007-.823-3.11-1.275.193-.468.364-.887.536-1.306.483-1.177.953-2.36,1.455-3.529.172-.4.139-.627-.305-.787-.689-.25-1.361-.55-2.109-.857-.749,1.824-1.464,3.569-2.2,5.357l-3.633-1.49c.729-1.78,1.445-3.525,2.194-5.351l-9-3.691c.845-2.062,1.657-4.04,2.5-6.1l2.659,1.091c2.871-7,5.71-13.92,8.575-20.9l-2.636-1.081,2.49-6.071,8.954,3.672,2.432-5.928,3.6,1.478-2.4,5.845,2.667,1.094C993.425,394.1,994.213,392.182,995.03,390.19Zm-10.574,24.39c-.6-.245-1.2-.474-1.792-.742-.387-.177-.576-.077-.732.307-.979,2.42-1.965,4.837-2.975,7.245-.195.465-.056.655.372.82,1.055.408,2.092.865,3.149,1.274a4.125,4.125,0,0,0,5.285-1.747,4.287,4.287,0,0,0-2.088-6.657C985.269,414.911,984.862,414.745,984.456,414.579Zm1.331-9.823c-.421,1.026-.833,2.057-1.268,3.078-.146.342-.111.557.263.7,1.1.416,2.183.893,3.3,1.26a2.578,2.578,0,0,0,3.1-1.078,8.846,8.846,0,0,0,1.043-2.174,3.251,3.251,0,0,0-2.011-4.164c-.81-.34-1.633-.65-2.434-1.007-.392-.176-.582-.08-.733.305C986.639,402.708,986.208,403.73,985.787,404.756Z",
    transform: "translate(-947.984 -374.357)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "ib_cls-4",
    d: "M1018.2,398.5a33.811,33.811,0,0,1,2.91,13.067,34.492,34.492,0,0,1-2.443,13.244,33.891,33.891,0,0,1-7.411,11.3,34.206,34.206,0,0,1-24.489,10.213,33.9,33.9,0,0,1-13.243-2.677,34.477,34.477,0,0,1-11.13-7.581,33.816,33.816,0,0,1-7.237-11.264,34.354,34.354,0,0,0,31.607,20.539,34.4,34.4,0,0,0,23.8-9.921A34.366,34.366,0,0,0,1018.2,398.5Z",
    transform: "translate(-945.671 -370.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "ib_cls-27",
    d: "M955.16,426.084a33.8,33.8,0,0,1-2.869-13.077,34.448,34.448,0,0,1,2.483-13.235,33.867,33.867,0,0,1,7.445-11.273,34.207,34.207,0,0,1,24.52-10.138,33.878,33.878,0,0,1,13.235,2.717,34.479,34.479,0,0,1,11.106,7.615,33.808,33.808,0,0,1,7.2,11.286,34.353,34.353,0,0,0-31.544-20.637,34.409,34.409,0,0,0-23.828,9.85,34.371,34.371,0,0,0-7.751,36.892Z",
    transform: "translate(-945.875 -372.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "ib_cls-4",
    d: "M974.142,395.95c.176-.52.361-1.035.547-1.549s.366-1.032.564-1.542l1.168-3.067.08-.211.219.086q4.508,1.761,8.953,3.675l-.3.123,1.294-2.931.666-1.458q.333-.73.681-1.452c-.171.507-.351,1.01-.535,1.512l-.548,1.506-1.139,3-.079.209-.216-.085q-4.509-1.758-8.955-3.671l.3-.124-1.323,3c-.218.5-.455,1-.681,1.493S974.381,395.456,974.142,395.95Z",
    transform: "translate(-944.316 -371.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "ib_cls-4",
    d: "M963.784,422.315c.371-1.035.764-2.06,1.148-3.09s.791-2.049,1.185-3.074l.063-.166.172.068,2.677,1.045-.3.125,2.111-5.24c.7-1.746,1.445-3.477,2.165-5.217s1.468-3.468,2.215-5.2,1.513-3.45,2.295-5.164c-.647,1.77-1.3,3.535-1.993,5.288s-1.359,3.513-2.072,5.256-1.4,3.5-2.122,5.234l-2.176,5.213-.09.215-.209-.09-2.64-1.136.235-.1c-.439,1.007-.861,2.021-1.316,3.021S964.246,421.317,963.784,422.315Z",
    transform: "translate(-945.055 -370.802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "ib_cls-4",
    d: "M978.294,420.281c.6.181,1.189.394,1.784.59l1.762.641a3.994,3.994,0,0,0,3.371-.447,4.794,4.794,0,0,0,1.959-2.866,4.515,4.515,0,0,0,.121-1.793,4.34,4.34,0,0,0-.574-1.743,4.353,4.353,0,0,1,.858,3.626,4.875,4.875,0,0,1-2.074,3.23,4.191,4.191,0,0,1-3.816.376C980.543,421.381,979.408,420.858,978.294,420.281Z",
    transform: "translate(-944.02 -369.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "ib_cls-4",
    d: "M983.509,407.534c.989.286,1.986.633,2.928.961a3.1,3.1,0,0,0,2.669-.643,4.485,4.485,0,0,0,1.455-2.469,5.093,5.093,0,0,0-.177-2.972,4.438,4.438,0,0,1,.581,3.051,4.505,4.505,0,0,1-1.521,2.808,3.335,3.335,0,0,1-3.135.629C985.329,408.483,984.431,408.021,983.509,407.534Z",
    transform: "translate(-943.648 -370.373)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    className: "ib_cls-4",
    d: "M972.329,424.035a13.967,13.967,0,0,1-.847,2.778,13.8,13.8,0,0,1-1.347,2.573,13.733,13.733,0,0,1,.847-2.778A13.938,13.938,0,0,1,972.329,424.035Z",
    transform: "translate(-944.602 -368.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    className: "ib_cls-4",
    d: "M978.021,426.449a13.782,13.782,0,0,1-.841,2.762,13.6,13.6,0,0,1-1.34,2.557,15.448,15.448,0,0,1,2.181-5.319Z",
    transform: "translate(-944.195 -368.659)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(136.346 11.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_9KWdk1-4",
    "data-name": "9KWdk1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    className: "ib_cls-22",
    d: "M1028.232,363.3a40.992,40.992,0,1,1-38.569-43.386A41,41,0,0,1,1028.232,363.3Z",
    transform: "translate(-946.319 -319.848)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(2.928 2.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    className: "ib_cls-23",
    d: "M984.975,398.648a38.063,38.063,0,1,1,40.138-35.713A38.037,38.037,0,0,1,984.975,398.648Zm36.2-35.337a34.162,34.162,0,1,0-37.048,31.363A34.183,34.183,0,0,0,1021.175,363.31Z",
    transform: "translate(-949.052 -322.581)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    className: "ib_cls-4",
    d: "M1011.754,336.874a33.82,33.82,0,0,1,7.025,11.4,34.495,34.495,0,0,1,2.025,13.313,33.875,33.875,0,0,1-3.307,13.1,34.2,34.2,0,0,1-19.8,17.663,33.876,33.876,0,0,1-13.391,1.8,34.459,34.459,0,0,1-13-3.522,33.807,33.807,0,0,1-10.525-8.275,34.36,34.36,0,0,0,36.589,9.068,34.412,34.412,0,0,0,19.241-17.161,34.369,34.369,0,0,0-4.859-37.384Z",
    transform: "translate(-945.287 -318.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    className: "ib_cls-24",
    d: "M961.166,383.068a33.81,33.81,0,0,1-6.989-11.418,34.485,34.485,0,0,1-1.984-13.319,33.88,33.88,0,0,1,3.348-13.089,34.2,34.2,0,0,1,19.854-17.6,33.861,33.861,0,0,1,13.395-1.762,34.451,34.451,0,0,1,12.988,3.562,33.8,33.8,0,0,1,10.5,8.307,34.362,34.362,0,0,0-36.56-9.18,34.4,34.4,0,0,0-19.293,17.1,34.37,34.37,0,0,0,4.745,37.4Z",
    transform: "translate(-945.903 -319.424)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(22.718 13.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1421394342400",
    "data-name": 1421394342400
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    className: "ib_cls-4",
    d: "M979.4,332.42l-.172,1.347,5.991,37.321.439.317,15.68-13.021Z",
    transform: "translate(-966.69 -332.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    className: "ib_cls-4",
    d: "M980.234,332.42l-12.71,31.525,18.968,7.459-2.908-18.114Z",
    transform: "translate(-967.524 -332.42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    className: "ib_cls-4",
    d: "M985.732,372.738l-.172.295,2.134,13.294.313.589,13.416-27.195Z",
    transform: "translate(-966.238 -330.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    className: "ib_cls-4",
    d: "M989.259,386.545l-2.276-14.177-18.967-7.454Z",
    transform: "translate(-967.489 -330.103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    className: "ib_cls-4",
    d: "M985.423,370.015l15.68-13.021L982.515,351.9Z",
    transform: "translate(-966.455 -331.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    className: "ib_cls-4",
    d: "M967.524,362.556l18.968,7.459L983.584,351.9Z",
    transform: "translate(-967.524 -331.031)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    className: "ib_cls-29",
    x2: 6.389,
    y2: 40.256,
    transform: "translate(12.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    className: "ib_cls-29",
    d: "M1002.172,356.995,983.584,351.9l-16.06,10.655",
    transform: "translate(-967.524 -331.031)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    className: "ib_cls-29",
    x2: 2.661,
    y2: 16.124,
    transform: "translate(19.199 40.877)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-3",
    "data-name": "Layer_1",
    transform: "translate(23.83 13.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1421394342400-2",
    "data-name": 1421394342400
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    className: "ib_cls-30",
    d: "M980.438,332.253l-.172,1.347,5.991,37.321.439.317,15.68-13.021Z",
    transform: "translate(-967.728 -332.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    className: "ib_cls-30",
    d: "M981.273,332.253l-12.71,31.526,18.968,7.459-2.908-18.114Z",
    transform: "translate(-968.563 -332.253)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    className: "ib_cls-30",
    d: "M986.771,372.571l-.172.294,2.134,13.294.313.589,13.415-27.195Z",
    transform: "translate(-967.276 -330.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    className: "ib_cls-30",
    d: "M990.3,386.378,988.022,372.2l-18.967-7.454Z",
    transform: "translate(-968.528 -329.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    className: "ib_cls-30",
    d: "M986.461,369.849l15.68-13.021-18.588-5.094Z",
    transform: "translate(-967.494 -330.864)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    className: "ib_cls-30",
    d: "M968.563,362.389l18.968,7.459-2.908-18.114Z",
    transform: "translate(-968.563 -330.864)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    className: "ib_cls-31",
    x2: 6.389,
    y2: 40.256,
    transform: "translate(12.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    className: "ib_cls-31",
    d: "M1003.21,356.828l-18.588-5.094-16.06,10.655",
    transform: "translate(-968.563 -330.864)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    className: "ib_cls-31",
    x2: 2.661,
    y2: 16.124,
    transform: "translate(19.199 40.877)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73",
    transform: "translate(5.639 11.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_9KWdk1-5",
    "data-name": "9KWdk1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    className: "ib_cls-22",
    d: "M906.122,357.45a40.992,40.992,0,1,1-44.73-37A41,41,0,0,1,906.122,357.45Z",
    transform: "translate(-824.312 -320.256)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(2.928 2.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    className: "ib_cls-23",
    d: "M868.783,398.942a38.063,38.063,0,1,1,34.229-41.413A38.04,38.04,0,0,1,868.783,398.942ZM899.177,358.5a34.162,34.162,0,1,0-31.837,36.641A34.183,34.183,0,0,0,899.177,358.5Z",
    transform: "translate(-827.045 -322.989)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    className: "ib_cls-4",
    d: "M885.733,333.91a33.808,33.808,0,0,1,8.679,10.194,34.477,34.477,0,0,1,4.029,12.849,33.868,33.868,0,0,1-1.273,13.449,34.2,34.2,0,0,1-16.878,20.474,33.877,33.877,0,0,1-12.959,3.822,34.481,34.481,0,0,1-13.383-1.5,33.808,33.808,0,0,1-11.661-6.576,34.356,34.356,0,0,0,37.542,3.387,34.415,34.415,0,0,0,16.4-19.893,34.369,34.369,0,0,0-10.5-36.206Z",
    transform: "translate(-823.03 -319.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    className: "ib_cls-24",
    d: "M842.916,387.128a33.771,33.771,0,0,1-8.648-10.219,34.478,34.478,0,0,1-3.991-12.861,33.864,33.864,0,0,1,1.315-13.446,34.2,34.2,0,0,1,16.94-20.422A33.885,33.885,0,0,1,861.5,326.4a34.443,34.443,0,0,1,13.378,1.542,33.785,33.785,0,0,1,11.642,6.611,34.361,34.361,0,0,0-37.531-3.5,34.412,34.412,0,0,0-16.463,19.844,34.37,34.37,0,0,0,10.389,36.237Z",
    transform: "translate(-823.9 -319.826)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-3",
    "data-name": "Layer 2",
    transform: "translate(14.75 14.74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-4",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    className: "ib_cls-4",
    d: "M851.221,362.316a3.635,3.635,0,0,0,4.435,2.592l.206-.066a3.634,3.634,0,1,0-4.641-2.525Z",
    transform: "translate(-837.152 -332.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    className: "ib_cls-4",
    d: "M838.96,365.069a1.175,1.175,0,1,0,1.434.838,1.167,1.167,0,0,0-1.434-.838Z",
    transform: "translate(-838.081 -331.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    className: "ib_cls-4",
    d: "M845.094,343.468a1.178,1.178,0,1,0-1.658-1.672,1.178,1.178,0,0,0,1.658,1.672Z",
    transform: "translate(-837.723 -333.484)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    className: "ib_cls-4",
    d: "M850.282,348.2a1.812,1.812,0,1,0-2.562-.019A1.815,1.815,0,0,0,850.282,348.2Z",
    transform: "translate(-837.43 -333.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    className: "ib_cls-4",
    d: "M840.4,355.671a1.5,1.5,0,1,0-1.048-1.841h0A1.491,1.491,0,0,0,840.4,355.671Z",
    transform: "translate(-837.994 -332.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    className: "ib_cls-4",
    d: "M844.853,362.545a1.816,1.816,0,1,0,2.218,1.3h0A1.817,1.817,0,0,0,844.853,362.545Z",
    transform: "translate(-837.694 -331.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    className: "ib_cls-4",
    d: "M846.51,373.972a1.5,1.5,0,1,0,2.12.012h0a1.5,1.5,0,0,0-2.12-.012Z",
    transform: "translate(-837.511 -331.196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    className: "ib_cls-4",
    d: "M848.279,358.034a2.132,2.132,0,1,0-1.5-2.617,2.117,2.117,0,0,0,1.5,2.617Z",
    transform: "translate(-837.465 -332.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    className: "ib_cls-4",
    d: "M865.43,343.165a1.818,1.818,0,1,0-1.267-2.238h0a1.8,1.8,0,0,0,1.267,2.238Z",
    transform: "translate(-836.225 -333.617)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    className: "ib_cls-4",
    d: "M866.861,336.327a1.175,1.175,0,1,0-.832-1.455,1.212,1.212,0,0,0,.832,1.455Z",
    transform: "translate(-836.09 -334.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    className: "ib_cls-4",
    d: "M869.015,352.932a3.632,3.632,0,1,0,1.845,7.027l.192-.061a3.63,3.63,0,0,0-2.037-6.966Z",
    transform: "translate(-836.068 -332.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    className: "ib_cls-4",
    d: "M853.808,356.119a3.637,3.637,0,1,0,.031-5.152,3.643,3.643,0,0,0-.031,5.152Z",
    transform: "translate(-837.034 -332.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "ib_cls-4",
    d: "M877.878,343.582a1.5,1.5,0,1,0-2.135-.008,1.522,1.522,0,0,0,2.135.008Z",
    transform: "translate(-835.425 -333.514)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "ib_cls-4",
    d: "M869.9,347.115a2.134,2.134,0,1,0,3.018.025A2.135,2.135,0,0,0,869.9,347.115Z",
    transform: "translate(-835.857 -333.124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    className: "ib_cls-4",
    d: "M855.8,339.423a1.5,1.5,0,1,0-1.833-1.087,1.517,1.517,0,0,0,1.833,1.087Z",
    transform: "translate(-836.951 -333.839)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    className: "ib_cls-4",
    d: "M858.536,347.859a2.133,2.133,0,1,0-2.608-1.518,2.119,2.119,0,0,0,2.608,1.518Z",
    transform: "translate(-836.813 -333.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    className: "ib_cls-4",
    d: "M854.574,370.523a2.133,2.133,0,1,0-3.017-.025A2.133,2.133,0,0,0,854.574,370.523Z",
    transform: "translate(-837.163 -331.672)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    className: "ib_cls-4",
    d: "M860.489,350.137a3.634,3.634,0,1,0,2.387-2.494A3.624,3.624,0,0,0,860.489,350.137Z",
    transform: "translate(-836.492 -333.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    className: "ib_cls-4",
    d: "M870.864,361.721a3.634,3.634,0,1,0-.036,5.139h0a3.617,3.617,0,0,0,.059-5.116C870.882,361.731,870.882,361.731,870.864,361.721Z",
    transform: "translate(-836.186 -332.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "ib_cls-4",
    d: "M876.193,359.605a2.132,2.132,0,1,0,1.5,2.617,2.119,2.119,0,0,0-1.5-2.617Z",
    transform: "translate(-835.555 -332.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "ib_cls-4",
    d: "M880.877,352.847a1.816,1.816,0,1,0-1.3,2.218h0A1.827,1.827,0,0,0,880.877,352.847Z",
    transform: "translate(-835.283 -332.768)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "ib_cls-4",
    d: "M884.788,350.169a1.175,1.175,0,1,0,1.435.838A1.183,1.183,0,0,0,884.788,350.169Z",
    transform: "translate(-834.812 -332.865)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "ib_cls-4",
    d: "M883.991,361.883a1.5,1.5,0,1,0,1.047,1.84,1.491,1.491,0,0,0-1.047-1.84Z",
    transform: "translate(-834.941 -332.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    className: "ib_cls-4",
    d: "M857.47,381.189a1.173,1.173,0,1,0,.815,1.446h0A1.156,1.156,0,0,0,857.47,381.189Z",
    transform: "translate(-836.804 -330.654)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    className: "ib_cls-4",
    d: "M879.25,374.044a1.178,1.178,0,0,0,1.659,1.672,1.178,1.178,0,0,0-1.659-1.672Z",
    transform: "translate(-835.169 -331.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    className: "ib_cls-4",
    d: "M864.183,367.7a3.65,3.65,0,1,0-2.4,2.5A3.581,3.581,0,0,0,864.183,367.7Z",
    transform: "translate(-836.729 -331.94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    className: "ib_cls-4",
    d: "M859,374.432a1.818,1.818,0,1,0,1.266,2.238h0A1.8,1.8,0,0,0,859,374.432Z",
    transform: "translate(-836.753 -331.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    className: "ib_cls-4",
    d: "M868.444,378.176a1.5,1.5,0,1,0,1.833,1.087,1.517,1.517,0,0,0-1.833-1.087Z",
    transform: "translate(-835.995 -330.869)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    className: "ib_cls-4",
    d: "M865.795,369.825a2.134,2.134,0,1,0,2.608,1.518,2.12,2.12,0,0,0-2.608-1.518Z",
    transform: "translate(-836.218 -331.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    className: "ib_cls-4",
    d: "M874.146,369.4a1.818,1.818,0,1,0,2.589.011,1.837,1.837,0,0,0-2.589-.011Z",
    transform: "translate(-835.547 -331.529)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-4",
    "data-name": "Layer 2",
    transform: "translate(15.172 14.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-5",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    className: "ib_cls-32",
    d: "M851.615,362.116a3.635,3.635,0,0,0,4.435,2.591l.206-.066a3.634,3.634,0,1,0-4.641-2.525Z",
    transform: "translate(-837.546 -332.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    className: "ib_cls-32",
    d: "M839.354,364.869a1.175,1.175,0,1,0,1.434.838,1.166,1.166,0,0,0-1.434-.838Z",
    transform: "translate(-838.475 -331.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    className: "ib_cls-32",
    d: "M845.489,343.268a1.178,1.178,0,1,0-1.659-1.672,1.178,1.178,0,0,0,1.659,1.672Z",
    transform: "translate(-838.117 -333.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    className: "ib_cls-32",
    d: "M850.677,348a1.812,1.812,0,1,0-2.562-.02A1.816,1.816,0,0,0,850.677,348Z",
    transform: "translate(-837.824 -333.023)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    className: "ib_cls-32",
    d: "M840.79,355.47a1.5,1.5,0,1,0-1.048-1.839h0A1.49,1.49,0,0,0,840.79,355.47Z",
    transform: "translate(-838.388 -332.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    className: "ib_cls-32",
    d: "M845.247,362.344a1.816,1.816,0,1,0,2.218,1.3h0A1.817,1.817,0,0,0,845.247,362.344Z",
    transform: "translate(-838.088 -331.783)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    className: "ib_cls-32",
    d: "M846.9,373.772a1.5,1.5,0,1,0,2.121.012h0a1.505,1.505,0,0,0-2.121-.012Z",
    transform: "translate(-837.905 -330.995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    className: "ib_cls-32",
    d: "M848.673,357.834a2.132,2.132,0,1,0-1.5-2.618,2.119,2.119,0,0,0,1.5,2.618Z",
    transform: "translate(-837.859 -332.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    className: "ib_cls-32",
    d: "M865.824,342.965a1.818,1.818,0,1,0-1.266-2.238h0a1.8,1.8,0,0,0,1.266,2.238Z",
    transform: "translate(-836.619 -333.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    className: "ib_cls-32",
    d: "M867.256,336.127a1.176,1.176,0,1,0-.832-1.456,1.212,1.212,0,0,0,.832,1.456Z",
    transform: "translate(-836.484 -333.814)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    className: "ib_cls-32",
    d: "M869.41,352.732a3.632,3.632,0,0,0,1.844,7.027l.192-.062a3.629,3.629,0,0,0-2.036-6.965Z",
    transform: "translate(-836.462 -332.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    className: "ib_cls-32",
    d: "M854.2,355.919a3.637,3.637,0,1,0,.031-5.153,3.642,3.642,0,0,0-.031,5.153Z",
    transform: "translate(-837.428 -332.68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    className: "ib_cls-32",
    d: "M878.272,343.381a1.5,1.5,0,1,0-2.134-.006,1.521,1.521,0,0,0,2.134.006Z",
    transform: "translate(-835.819 -333.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    className: "ib_cls-32",
    d: "M870.291,346.915a2.134,2.134,0,1,0,3.018.024A2.134,2.134,0,0,0,870.291,346.915Z",
    transform: "translate(-836.251 -332.923)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    className: "ib_cls-32",
    d: "M856.2,339.223a1.5,1.5,0,1,0-1.833-1.087,1.517,1.517,0,0,0,1.833,1.087Z",
    transform: "translate(-837.345 -333.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    className: "ib_cls-32",
    d: "M858.93,347.66a2.134,2.134,0,1,0-2.607-1.518,2.12,2.12,0,0,0,2.607,1.518Z",
    transform: "translate(-837.207 -333.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    className: "ib_cls-32",
    d: "M854.969,370.323a2.134,2.134,0,1,0-3.018-.025A2.136,2.136,0,0,0,854.969,370.323Z",
    transform: "translate(-837.557 -331.471)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    className: "ib_cls-32",
    d: "M860.884,349.936a3.633,3.633,0,1,0,2.386-2.494A3.623,3.623,0,0,0,860.884,349.936Z",
    transform: "translate(-836.886 -332.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    className: "ib_cls-32",
    d: "M871.258,361.521a3.634,3.634,0,1,0-.035,5.138h0a3.616,3.616,0,0,0,.058-5.116C871.276,361.531,871.276,361.531,871.258,361.521Z",
    transform: "translate(-836.58 -331.915)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    className: "ib_cls-32",
    d: "M876.587,359.4a2.132,2.132,0,1,0,1.5,2.618,2.118,2.118,0,0,0-1.5-2.618Z",
    transform: "translate(-835.949 -331.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    className: "ib_cls-32",
    d: "M881.271,352.647a1.817,1.817,0,1,0-1.3,2.218h0A1.826,1.826,0,0,0,881.271,352.647Z",
    transform: "translate(-835.677 -332.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    className: "ib_cls-32",
    d: "M885.183,349.968a1.175,1.175,0,1,0,1.434.838A1.185,1.185,0,0,0,885.183,349.968Z",
    transform: "translate(-835.206 -332.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    className: "ib_cls-32",
    d: "M884.385,361.683a1.5,1.5,0,1,0,1.048,1.839,1.49,1.49,0,0,0-1.048-1.839Z",
    transform: "translate(-835.335 -331.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    className: "ib_cls-32",
    d: "M857.865,380.989a1.174,1.174,0,1,0,.814,1.445h0A1.154,1.154,0,0,0,857.865,380.989Z",
    transform: "translate(-837.198 -330.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    className: "ib_cls-32",
    d: "M879.645,373.843a1.178,1.178,0,1,0,1.658,1.673,1.178,1.178,0,0,0-1.658-1.673Z",
    transform: "translate(-835.563 -330.983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    className: "ib_cls-32",
    d: "M864.577,367.5a3.65,3.65,0,1,0-2.4,2.5A3.578,3.578,0,0,0,864.577,367.5Z",
    transform: "translate(-837.123 -331.739)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    className: "ib_cls-32",
    d: "M859.394,374.231a1.819,1.819,0,1,0,1.267,2.238h0A1.8,1.8,0,0,0,859.394,374.231Z",
    transform: "translate(-837.147 -330.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    className: "ib_cls-32",
    d: "M868.839,377.976a1.5,1.5,0,1,0,1.833,1.087,1.516,1.516,0,0,0-1.833-1.087Z",
    transform: "translate(-836.389 -330.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    className: "ib_cls-32",
    d: "M866.189,369.625a2.133,2.133,0,1,0,2.608,1.518,2.119,2.119,0,0,0-2.608-1.518Z",
    transform: "translate(-836.612 -331.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    className: "ib_cls-32",
    d: "M874.539,369.2a1.819,1.819,0,1,0,2.59.012,1.82,1.82,0,0,0-2.59-.012Z",
    transform: "translate(-835.941 -331.328)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_9KWdk1-6",
    "data-name": "9KWdk1",
    transform: "translate(74.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    className: "ib_cls-25",
    d: "M970.358,368.52a42.5,42.5,0,1,1-22.524-55.81A42.509,42.509,0,0,1,970.358,368.52Z",
    transform: "translate(-888.75 -309.33)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    className: "ib_cls-26",
    transform: "translate(3.037 3.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M915.72,388a39.461,39.461,0,1,1,51.643-20.869A39.437,39.437,0,0,1,915.72,388Zm47.666-21.876a35.416,35.416,0,1,0-47.109,17.7A35.437,35.437,0,0,0,963.386,366.123Z",
    transform: "translate(-891.585 -312.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M939.5,327.753l3.742,1.578-.454,1.078c-.616,1.459-1.211,2.927-1.857,4.372-.24.538-.1.749.392,1.049a30.993,30.993,0,0,1,4.227,2.82c3.288,2.845,3.911,6.5,1.936,10.383a18.372,18.372,0,0,1-1.185,2.052,6.246,6.246,0,0,1-4.863,2.689c-.474.043-.948.066-1.514.105.507.518.975.953,1.393,1.431a8.469,8.469,0,0,1,1.575,9.246,12.409,12.409,0,0,1-2.523,4.235,8.145,8.145,0,0,1-5.865,2.573,19.425,19.425,0,0,1-7.487-1.493c-.568-.213-.829-.176-1.069.431-.573,1.448-1.237,2.86-1.841,4.3-.149.357-.331.513-.7.359-1.036-.434-2.071-.872-3.211-1.353l.569-1.348c.512-1.216,1.011-2.437,1.544-3.645.183-.412.151-.648-.309-.82-.712-.265-1.4-.583-2.178-.91l-2.332,5.531-3.752-1.582,2.33-5.524-9.292-3.918,2.654-6.294,2.745,1.157,9.1-21.585-2.722-1.147,2.643-6.269,9.245,3.9,2.581-6.12,3.721,1.569c-.837,1.986-1.678,3.981-2.544,6.035l2.753,1.161Zm-11.209,25.178c-.617-.26-1.244-.5-1.85-.788-.4-.187-.6-.086-.762.312q-1.56,3.749-3.157,7.481c-.207.48-.064.679.376.854,1.091.434,2.161.917,3.251,1.352a4.276,4.276,0,0,0,5.5-1.758,4.444,4.444,0,0,0-2.1-6.922C929.131,353.284,928.711,353.108,928.291,352.931Zm1.479-10.17c-.447,1.06-.885,2.123-1.346,3.178-.155.354-.122.576.266.727,1.138.441,2.254.948,3.409,1.339a2.673,2.673,0,0,0,3.22-1.085,9.182,9.182,0,0,0,1.1-2.243,3.371,3.371,0,0,0-2.043-4.338c-.836-.36-1.685-.69-2.513-1.069-.4-.184-.6-.088-.762.31C930.676,340.647,930.217,341.7,929.771,342.761Z",
    transform: "translate(-890.501 -311.248)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    className: "ib_cls-4",
    d: "M963.426,336.574a35.042,35.042,0,0,1,2.883,13.577,35.729,35.729,0,0,1-2.667,13.7,35.1,35.1,0,0,1-7.8,11.634,35.456,35.456,0,0,1-25.491,10.339,35.13,35.13,0,0,1-13.7-2.91,35.721,35.721,0,0,1-11.461-7.972A35.054,35.054,0,0,1,897.8,363.2a35.619,35.619,0,0,0,32.558,21.614,35.664,35.664,0,0,0,24.771-10.045,35.628,35.628,0,0,0,8.294-38.192Z",
    transform: "translate(-888.105 -307.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    className: "ib_cls-27",
    d: "M897.8,364.554a35.047,35.047,0,0,1-2.841-13.585,35.733,35.733,0,0,1,2.708-13.7,35.113,35.113,0,0,1,7.832-11.611A35.45,35.45,0,0,1,931.026,315.4a35.124,35.124,0,0,1,13.693,2.95,35.731,35.731,0,0,1,11.437,8.008,35.055,35.055,0,0,1,7.352,11.772,35.624,35.624,0,0,0-32.493-21.713,35.674,35.674,0,0,0-24.8,9.97,35.629,35.629,0,0,0-8.411,38.167Z",
    transform: "translate(-888.307 -308.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    className: "ib_cls-4",
    d: "M917.77,333.521c.187-.537.385-1.069.584-1.6s.39-1.066.6-1.593l1.241-3.169.086-.216.225.09q4.655,1.872,9.244,3.9l-.309.125,1.371-3.026.706-1.5c.235-.5.474-1,.721-1.5-.183.524-.375,1.043-.57,1.562l-.584,1.556-1.211,3.1-.083.214-.225-.089q-4.657-1.869-9.245-3.9l.311-.126-1.4,3.1c-.23.518-.481,1.027-.721,1.542S918.023,333.012,917.77,333.521Z",
    transform: "translate(-886.681 -308.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    className: "ib_cls-4",
    d: "M906.776,360.749c.4-1.069.813-2.129,1.221-3.191s.841-2.117,1.26-3.175l.068-.17.178.071,2.764,1.111-.311.126,2.242-5.41c.747-1.8,1.533-3.591,2.3-5.387s1.557-3.581,2.349-5.365,1.6-3.561,2.432-5.331c-.689,1.828-1.388,3.652-2.119,5.463s-1.445,3.627-2.2,5.427-1.484,3.611-2.254,5.4l-2.308,5.382-.1.223-.216-.1-2.725-1.205.245-.1c-.466,1.038-.914,2.085-1.395,3.118S907.266,359.719,906.776,360.749Z",
    transform: "translate(-887.465 -307.569)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    className: "ib_cls-4",
    d: "M921.825,358.791c.621.194,1.23.42,1.845.63l1.82.681a4.139,4.139,0,0,0,3.5-.429,4.976,4.976,0,0,0,2.06-2.951,4.677,4.677,0,0,0,.143-1.858,4.507,4.507,0,0,0-.577-1.813,4.508,4.508,0,0,1,.853,3.768,5.051,5.051,0,0,1-2.183,3.327,4.339,4.339,0,0,1-3.958.351C924.146,359.954,922.976,359.4,921.825,358.791Z",
    transform: "translate(-886.392 -306.212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    className: "ib_cls-4",
    d: "M927.361,345.63c1.022.306,2.053.677,3.026,1.026a3.208,3.208,0,0,0,2.772-.64,4.655,4.655,0,0,0,1.534-2.544,5.274,5.274,0,0,0-.154-3.083,4.592,4.592,0,0,1,.571,3.169,4.669,4.669,0,0,1-1.6,2.9,3.458,3.458,0,0,1-3.257.619C929.238,346.633,928.312,346.144,927.361,345.63Z",
    transform: "translate(-885.997 -307.115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    className: "ib_cls-4",
    d: "M915.6,362.626a14.444,14.444,0,0,1-.907,2.871,14.273,14.273,0,0,1-1.423,2.654,14.3,14.3,0,0,1,.907-2.87A14.484,14.484,0,0,1,915.6,362.626Z",
    transform: "translate(-887.001 -305.529)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    className: "ib_cls-4",
    d: "M921.48,365.187a14.225,14.225,0,0,1-.9,2.854,14.049,14.049,0,0,1-1.415,2.638,16.055,16.055,0,0,1,2.316-5.492Z",
    transform: "translate(-886.581 -305.347)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(0 69.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    className: "ib_cls-33",
    d: "M1026.073,453.537H845.505l-20.246-75.965h221.06Z",
    transform: "translate(-818.606 -373.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    className: "ib_cls-33",
    d: "M870,453.537l-14.265-75.965H1011.5L997.23,453.537",
    transform: "translate(-816.432 -373.746)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    className: "ib_cls-33",
    d: "M897.445,453.537l-7.565-75.965h82.6l-7.565,75.965",
    transform: "translate(-813.997 -373.746)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    className: "ib_cls-33",
    y2: 75.965,
    transform: "translate(117.184 3.826)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    className: "ib_cls-34",
    width: 234.367,
    height: 5.423,
    rx: 1.424
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    className: "ib_cls-33",
    x2: 212.722,
    transform: "translate(10.822 18.995)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    className: "ib_cls-33",
    x2: 203.217,
    transform: "translate(15.575 34.687)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    className: "ib_cls-33",
    x2: 194.502,
    transform: "translate(19.932 50.379)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    className: "ib_cls-35",
    x2: 186.705,
    transform: "translate(23.831 66.071)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "sucker-back",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    className: "ib_cls-8",
    cx: 80.172,
    cy: 19.122,
    rx: 80.172,
    ry: 19.122,
    transform: "translate(0 74.665) rotate(-27.753)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    className: "ib_cls-9",
    cx: 80.172,
    cy: 19.122,
    rx: 80.172,
    ry: 19.122,
    transform: "translate(0 74.665) rotate(-27.753)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "ib_cls-8",
    d: "M270.852,347.676a289.517,289.517,0,0,0,40.341-17.682,289.535,289.535,0,0,0,37.421-23.235,309.34,309.34,0,0,0-77.762,40.917Z",
    transform: "translate(-222.435 -258.817)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "money",
    transform: "translate(0 43.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(40.34 136.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    className: "ib_cls-36",
    d: "M213.989,295.908c-19.4-30.29,6.01-38.921-13.395-69.211-12.274-1.852-18.411-2.778-30.685-4.628,21.582,23.774-2.341,37.82,18.45,62.132C198.612,288.883,203.738,291.224,213.989,295.908Z",
    transform: "translate(-169.91 -222.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    className: "ib_cls-27",
    d: "M213.989,295.908c-19.4-30.29,6.01-38.921-13.395-69.211-12.274-1.852-18.411-2.778-30.685-4.628,21.582,23.774-2.341,37.82,18.45,62.132C198.612,288.883,203.738,291.224,213.989,295.908Z",
    transform: "translate(-169.91 -222.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    className: "ib_cls-37",
    d: "M203.753,284.006a.954.954,0,0,0-1.009.726,3.236,3.236,0,0,0,.34,2.029l-12.634-5.454a8.422,8.422,0,0,0-4.888-4.663c-10.062-20.182,4.245-24.9-5.815-45.084a1.574,1.574,0,0,0,1.3-.958,2.84,2.84,0,0,0-.171-2.092l16.055,2.763a15.552,15.552,0,0,0,5.163,4.445c5.456,19.278-3.795,29.011,1.657,48.288m1.711,1.809c-6.657-20.8,3.972-30.41-2.685-51.211-1.849-.335-4.211-2.423-5.745-4.787l-18.3-3.041c1.544,2.219.916,3.637-.942,3.3,11.837,21.43-4.17,26.031,7.668,47.46a7.319,7.319,0,0,1,4.346,4.588l15.232,6.685c-1.542-2.372-1.125-3.648.427-3Z",
    transform: "translate(-169.348 -221.733)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    className: "ib_cls-15",
    transform: "translate(14.821 26.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M193.3,246.663a9.986,9.986,0,0,1,7.352,11.265c-.989,4.957-5.052,7.876-9.492,6.378s-7.918-6.606-7.352-11.265A7.371,7.371,0,0,1,193.3,246.663Zm-.108,1.7a6.041,6.041,0,0,0-7.79,5.142,8.933,8.933,0,0,0,5.867,9.1c3.629,1.191,7.019-1.145,7.788-5.143A8.081,8.081,0,0,0,193.189,248.361Z",
    transform: "translate(-183.745 -246.394)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(0 59.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    className: "ib_cls-36",
    d: "M132.255,159.554c35.032,8.174,22.837,32.085,57.87,40.259l25.217-18.084c-32.046-1.986-24.7-28.737-56.555-31.658Z",
    transform: "translate(-132.255 -150.071)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    className: "ib_cls-37",
    d: "M146.541,160.921a.955.955,0,0,0,.216-1.226,3.23,3.23,0,0,0-1.658-1.216l12.858-4.9a8.425,8.425,0,0,0,6.756-.069c21.287,7.447,14.326,20.807,35.611,28.255a1.573,1.573,0,0,0-.267,1.6,2.84,2.84,0,0,0,1.582,1.38l-13.432,9.218a15.572,15.572,0,0,0-6.8.415c-17.354-10.01-17.514-23.438-34.865-33.45m-2.488-.1c19.276,10.264,18.361,24.564,37.64,34.828,1.559-1.05,4.708-1.2,7.455-.577l15.237-10.585c-2.653-.513-3.193-1.967-1.626-3.021-23.429-7.1-15.167-21.563-38.6-28.665a7.318,7.318,0,0,1-6.316-.257l-15.578,5.832c2.759.625,3.351,1.83,1.784,2.445Z",
    transform: "translate(-131.541 -149.895)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    className: "ib_cls-15",
    transform: "translate(32.554 14.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M177.346,178.882a9.988,9.988,0,0,1-13.126-2.945c-2.749-4.243-1.872-9.168,2.355-11.191s10.281-.788,13.126,2.945A7.371,7.371,0,0,1,177.346,178.882Zm-1.107-1.293a6.04,6.04,0,0,0,2-9.117,8.933,8.933,0,0,0-10.554-2.434c-3.431,1.678-4.232,5.717-1.995,9.118A8.081,8.081,0,0,0,176.239,177.589Z",
    transform: "translate(-162.642 -163.78)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(93.314 186.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    className: "ib_cls-36",
    d: "M219.357,278.1c35.032,8.174,22.837,32.085,57.869,40.259,10.088-7.234,15.131-10.849,25.218-18.084-32.046-1.986-24.7-28.737-56.555-31.658Z",
    transform: "translate(-219.357 -268.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    className: "ib_cls-37",
    d: "M233.642,279.462a.955.955,0,0,0,.217-1.226,3.24,3.24,0,0,0-1.658-1.216l12.858-4.9a8.425,8.425,0,0,0,6.756-.069c21.286,7.447,14.325,20.807,35.61,28.255a1.573,1.573,0,0,0-.268,1.6,2.845,2.845,0,0,0,1.582,1.381L275.308,312.5a15.566,15.566,0,0,0-6.8.415c-17.355-10.01-17.514-23.438-34.866-33.45m-2.488-.1c19.277,10.264,18.362,24.564,37.64,34.828,1.559-1.05,4.708-1.2,7.456-.577,6.095-4.233,9.143-6.35,15.237-10.585-2.654-.513-3.193-1.967-1.627-3.021-23.429-7.1-15.167-21.563-38.6-28.665a7.316,7.316,0,0,1-6.315-.257l-15.578,5.832c2.759.625,3.351,1.83,1.783,2.445Z",
    transform: "translate(-218.643 -268.436)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    className: "ib_cls-15",
    transform: "translate(32.553 14.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M264.447,297.423a9.986,9.986,0,0,1-13.125-2.945c-2.749-4.242-1.873-9.168,2.355-11.191s10.28-.788,13.126,2.945A7.371,7.371,0,0,1,264.447,297.423Zm-1.106-1.293a6.04,6.04,0,0,0,2-9.117,8.934,8.934,0,0,0-10.554-2.434c-3.431,1.678-4.232,5.717-2,9.118A8.081,8.081,0,0,0,263.341,296.13Z",
    transform: "translate(-249.743 -282.321)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(112.026 134.423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    className: "ib_cls-36",
    d: "M236.824,245.156c34.594-9.867,35.545,16.957,70.139,7.09,5.305-11.221,7.959-16.832,13.263-28.055-28.979,13.827-35.546-13.126-64.813-.21C247.977,232.451,244.261,236.686,236.824,245.156Z",
    transform: "translate(-236.824 -220.37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    className: "ib_cls-37",
    d: "M250.094,239.076a.955.955,0,0,0-.4-1.177,3.247,3.247,0,0,0-2.041-.258l8.86-10.529a8.422,8.422,0,0,0,5.872-3.34c22.224-3.828,22.627,11.233,44.852,7.406a1.572,1.572,0,0,0,.541,1.524,2.84,2.84,0,0,0,2.054.438l-7.267,14.58a15.553,15.553,0,0,0-5.742,3.666c-20.033-.324-26.693-11.984-46.723-12.309m-2.225,1.116c21.837-.388,27.981,12.557,49.817,12.168.853-1.674,3.533-3.336,6.237-4.126,3.273-6.66,4.909-9.991,8.181-16.653-2.569.84-3.746-.169-2.889-1.851-23.93,5.169-23.731-11.484-47.66-6.315a7.316,7.316,0,0,1-5.646,2.842c-4.314,5.065-6.471,7.6-10.786,12.664,2.715-.794,3.818-.028,2.746,1.271Z",
    transform: "translate(-236.232 -220.225)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    className: "ib_cls-15",
    transform: "translate(33.57 7.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M285.762,239.43a9.988,9.988,0,0,1-12.9,3.8c-4.463-2.374-6.089-7.106-3.376-10.926s8.6-5.681,12.9-3.8A7.372,7.372,0,0,1,285.762,239.43Zm-1.6-.592a6.039,6.039,0,0,0-2.683-8.939,8.934,8.934,0,0,0-10.408,3c-2.184,3.133-.922,7.052,2.684,8.939A8.08,8.08,0,0,0,284.167,238.837Z",
    transform: "translate(-268.159 -227.763)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(77.116 63.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    className: "ib_cls-36",
    d: "M204.238,164.332c36.76,8.955,19.17,33.488,55.931,42.441l30.406-19.492c-33.519-5.475-22.442-27.807-55.961-33.283C222.464,158.132,216.387,160.2,204.238,164.332Z",
    transform: "translate(-204.238 -153.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    className: "ib_cls-38",
    d: "M204.238,164.332c36.76,8.955,19.17,33.488,55.931,42.441l30.406-19.492c-33.519-5.475-22.442-27.807-55.961-33.283C222.464,158.132,216.387,160.2,204.238,164.332Z",
    transform: "translate(-204.238 -153.999)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    className: "ib_cls-15",
    transform: "translate(10.578 2.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M219.246,166.449a1.182,1.182,0,0,0,.238-1.3,2.771,2.771,0,0,0-1.43-1.234l14.476-5.9a25.4,25.4,0,0,0,6.81-.074c21.592,7.356,13.373,21.417,34.963,28.774a1.913,1.913,0,0,0-.314,1.663,2.557,2.557,0,0,0,1.349,1.422l-14.614,9.988a18.492,18.492,0,0,0-6.968.621c-17.6-10.273-16.913-23.69-34.51-33.964m-3.459-.005c20.229,10.614,17.916,25.152,38.143,35.766,1.762-1.188,5.151-1.464,8.026-.883l17.249-11.963c-2.785-.466-3.239-2.014-1.47-3.206-24.492-6.82-14.051-22.622-38.544-29.441-1.739.723-5.035.728-7.821.262l-17.259,6.879c2.887.584,3.414,1.864,1.674,2.586Z",
    transform: "translate(-214.112 -156.716)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    className: "ib_cls-15",
    transform: "translate(33.041 15.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M237.831,180.675c-1.912-3.576-.4-7.869,3.6-9.687s9.1-.766,11.134,2.454.516,7.517-3.6,9.688-9.223,1.122-11.134-2.455m-1.722.845c2.341,4.463,8.76,5.7,13.856,2.969s6.849-7.97,4.325-11.891-8.928-5.163-13.857-2.97a8.439,8.439,0,0,0-4.324,11.892Z",
    transform: "translate(-235.079 -168.553)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(13.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    className: "ib_cls-36",
    d: "M228.5,133.156c-35.29-6.974-23.919-31.287-59.209-38.261-9.835,7.573-14.753,11.359-24.586,18.934,32.1.89,25.664,27.877,57.6,29.71C212.78,139.386,218.017,137.308,228.5,133.156Z",
    transform: "translate(-144.701 -94.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    className: "ib_cls-27",
    d: "M228.5,133.156c-35.29-6.974-23.919-31.287-59.209-38.261-9.835,7.573-14.753,11.359-24.586,18.934,32.1.89,25.664,27.877,57.6,29.71C212.78,139.386,218.017,137.308,228.5,133.156Z",
    transform: "translate(-144.701 -94.895)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    className: "ib_cls-37",
    d: "M212.778,131.877a.955.955,0,0,0-.176,1.232,3.237,3.237,0,0,0,1.7,1.159c-5.369,2.26-7.313,3.079-12.683,5.338a8.421,8.421,0,0,0-6.748.3c-21.529-6.716-15.027-20.306-36.555-27.023a1.573,1.573,0,0,0,.213-1.6,2.842,2.842,0,0,0-1.628-1.325l13.11-9.67a15.571,15.571,0,0,0,6.783-.647c17.686,9.413,18.3,22.826,35.987,32.24m2.49.019c-19.616-9.6-19.189-23.924-38.806-33.524-1.522,1.1-4.665,1.359-7.432.831l-14.868,11.1c2.67.422,3.258,1.857,1.729,2.963,23.658,6.3,15.893,21.034,39.551,27.331a7.317,7.317,0,0,1,6.321.042l15.37-6.36c-2.778-.53-3.411-1.714-1.865-2.383Z",
    transform: "translate(-144.026 -94.647)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    className: "ib_cls-15",
    transform: "translate(32.095 18.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M178.436,113.269a9.988,9.988,0,0,1,13.219,2.5c2.891,4.146,2.183,9.1-1.972,11.264s-10.247,1.139-13.218-2.5A7.372,7.372,0,0,1,178.436,113.269Zm1.151,1.255a6.04,6.04,0,0,0-1.683,9.18,8.931,8.931,0,0,0,10.63,2.072c3.372-1.793,4.033-5.858,1.683-9.181A8.082,8.082,0,0,0,179.587,114.524Z",
    transform: "translate(-174.66 -111.792)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "machine",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sucker",
    "data-name": "Group 8",
    transform: "translate(100.064 223.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(74.434 84.054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "ib_cls-2",
    d: "M464.851,501.51l-106.476-39.2a51.518,51.518,0,0,1-21.064-14.525l-42.174-48.462,67.634-58.861,27.086,31.122a51.523,51.523,0,0,0,21.063,14.524l84.9,31.256Z",
    transform: "translate(-295.137 -340.467)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    className: "ib_cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "ib_cls-4",
    d: "M464.851,501.51l-106.476-39.2a51.518,51.518,0,0,1-21.064-14.525l-42.174-48.462,67.634-58.861,27.086,31.122a51.523,51.523,0,0,0,21.063,14.524l84.9,31.256Z",
    transform: "translate(-295.137 -340.467)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "ib_cls-5",
    d: "M365.47,440.509l8.848-15.491a2.749,2.749,0,0,0-4.015-3.578L351.71,435.1a5.941,5.941,0,0,1-7.34-.26c-26.054-21.992-28.3-42.026-28.3-42.026l-7.9-7.993-13.034,11.343,42.174,48.462a51.508,51.508,0,0,0,21.065,14.525l88.094,32.429,1.751-14.273c-30.295-4.126-66.746-21.656-80.331-28.621A5.9,5.9,0,0,1,365.47,440.509Z",
    transform: "translate(-295.137 -337.304)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(88.395 114.093)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    className: "ib_cls-6",
    cx: 2.886,
    cy: 2.886,
    r: 2.886,
    transform: "translate(0 33.036)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "ib_cls-6",
    d: "M333.642,396.7a2.886,2.886,0,1,1-2.886-2.887A2.887,2.887,0,0,1,333.642,396.7Z",
    transform: "translate(-306.764 -366.701)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    className: "ib_cls-6",
    cx: 2.886,
    cy: 2.886,
    r: 2.886,
    transform: "translate(43.348 14.593)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "ib_cls-6",
    d: "M373.491,371.392a2.886,2.886,0,1,1-2.886-2.886A2.886,2.886,0,0,1,373.491,371.392Z",
    transform: "translate(-303.923 -368.506)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(8.904 16.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "ib_cls-2",
    d: "M344.247,389.876c17.928-9.434,32.011-20.074,37.172-27.437L375.87,277.8l-141.9,74.665,66.61,52.506C309.573,404.891,326.318,399.31,344.247,389.876Z",
    transform: "translate(-233.97 -277.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "ib_cls-6",
    d: "M344.247,389.782c17.928-9.434,32.011-20.075,37.172-27.438l-5.549-84.635-141.9,74.665,66.61,52.506C309.573,404.8,326.318,399.215,344.247,389.782Z",
    transform: "translate(-233.97 -277.709)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "ib_cls-7",
    d: "M320.429,396.371l-59.808-60.536-1.11-.882-25.541,13.44L300.58,400.9C305.343,400.855,312.293,399.254,320.429,396.371Z",
    transform: "translate(-233.97 -273.627)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(191.685 259.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(134.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    className: "ib_cls-2",
    width: 316.397,
    height: 241.742,
    transform: "translate(0.089)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    className: "ib_cls-10",
    width: 316.397,
    height: 241.742
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    className: "ib_cls-11",
    transform: "translate(0 36.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "ib_cls-4",
    d: "M329.764,350.638l3.054,5.447-5.921,7.209-3.054-5.447Z",
    transform: "translate(-310.277 -328.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "ib_cls-4",
    d: "M332.4,373.118l-3.054-5.447,5.921-7.209,3.054,5.446Z",
    transform: "translate(-309.884 -328.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "ib_cls-4",
    d: "M340.781,370.286l3.125,5.573-7.58,4.25-1.466-2.615Z",
    transform: "translate(-309.491 -327.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "ib_cls-4",
    d: "M313.495,330.346l17.886,8.22-6.31,3.539,2.749,4.9-5.921,7.209-4.408-7.862-6.31,3.539Z",
    transform: "translate(-311.18 -330.346)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(519.251 328.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "ib_cls-10",
    d: "M707.5,368.238v97.777a7.259,7.259,0,0,1-1.517,4.474,19.738,19.738,0,0,1-9.243,2.266H643.8a20.111,20.111,0,0,1-20.1-20.1V371.865a19.952,19.952,0,0,1,2.5-9.717c-.276.159-.532.3-.789.474a7.35,7.35,0,0,1,4.907-1.852h69.711A7.477,7.477,0,0,1,707.5,368.238Z",
    transform: "translate(-616.459 -360.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "ib_cls-5",
    d: "M637.054,480.552h52.933a20.1,20.1,0,0,0,17.6-10.392,20.019,20.019,0,0,1-9.72,2.508H644.937a20.112,20.112,0,0,1-20.112-20.113V371.772a20,20,0,0,1,2.509-9.721,20.1,20.1,0,0,0-10.393,17.6v80.784A20.112,20.112,0,0,0,637.054,480.552Z",
    transform: "translate(-616.941 -360.678)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "ib_cls-10",
    d: "M560.441,368.238v97.777a7.254,7.254,0,0,1-1.518,4.474,19.734,19.734,0,0,1-9.243,2.266H496.741a20.111,20.111,0,0,1-20.1-20.1V371.865a19.963,19.963,0,0,1,2.5-9.717c-.276.159-.532.3-.787.474a7.35,7.35,0,0,1,4.907-1.852h69.71A7.478,7.478,0,0,1,560.441,368.238Z",
    transform: "translate(-107.695 -31.939)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "ib_cls-5",
    d: "M559.921,470.16a20.1,20.1,0,0,1-17.6,10.386H489.382a20.111,20.111,0,0,1-20.1-20.1V379.657a20.057,20.057,0,0,1,9.6-17.127c.255-.178.511-.315.787-.474a19.963,19.963,0,0,0-2.5,9.717v80.788a20.111,20.111,0,0,0,20.1,20.1H550.2a19.734,19.734,0,0,0,9.243-2.266A5,5,0,0,0,559.921,470.16Z",
    transform: "translate(-108.22 -31.847)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(466.786 349.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "ib_cls-8",
    d: "M601.537,391.442h-27.9a5.668,5.668,0,0,1-5.667-5.667h0a5.667,5.667,0,0,1,5.667-5.667h27.9a5.666,5.666,0,0,1,5.666,5.667h0A5.667,5.667,0,0,1,601.537,391.442Z",
    transform: "translate(-567.968 -380.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "ib_cls-8",
    d: "M601.537,411.865h-27.9a5.668,5.668,0,0,1-5.667-5.667h0a5.667,5.667,0,0,1,5.667-5.667h27.9A5.667,5.667,0,0,1,607.2,406.2h0A5.667,5.667,0,0,1,601.537,411.865Z",
    transform: "translate(-567.968 -378.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "ib_cls-8",
    d: "M601.537,432.285h-27.9a5.667,5.667,0,0,1-5.667-5.667h0a5.667,5.667,0,0,1,5.667-5.666h27.9a5.666,5.666,0,0,1,5.666,5.666h0A5.666,5.666,0,0,1,601.537,432.285Z",
    transform: "translate(-567.968 -377.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "ib_cls-8",
    d: "M601.537,452.708h-27.9a5.667,5.667,0,0,1-5.667-5.667h0a5.668,5.668,0,0,1,5.667-5.667h27.9a5.667,5.667,0,0,1,5.666,5.667h0A5.666,5.666,0,0,1,601.537,452.708Z",
    transform: "translate(-567.968 -375.739)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(356.205 20.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    className: "ib_cls-8",
    width: 255.856,
    height: 194.113,
    rx: 10.758
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    className: "ib_cls-12",
    width: 255.856,
    height: 194.113,
    rx: 10.758
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(8.558 8.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    className: "ib_cls-13",
    d: "M6.335,0h226.07a6.335,6.335,0,0,1,6.335,6.335V170.662A6.336,6.336,0,0,1,232.4,177H6.336A6.336,6.336,0,0,1,0,170.661V6.335A6.335,6.335,0,0,1,6.335,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    className: "ib_cls-6",
    d: "M6.335,0h226.07a6.335,6.335,0,0,1,6.335,6.335V170.662A6.336,6.336,0,0,1,232.4,177H6.336A6.336,6.336,0,0,1,0,170.661V6.335A6.335,6.335,0,0,1,6.335,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(60.73 180.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(37.796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "ib_cls-8",
    d: "M615.52,297.519l-4.279-56.1H560.995l-4.279,56.1Z",
    transform: "translate(-556.716 -241.417)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(0 47.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "ib_cls-8",
    d: "M649.972,297.227H527.3a5.859,5.859,0,0,1-5.859-5.859h0a5.859,5.859,0,0,1,5.859-5.86H649.972a5.86,5.86,0,0,1,5.86,5.86h0A5.86,5.86,0,0,1,649.972,297.227Z",
    transform: "translate(-521.436 -285.508)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(0 0.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    className: "ib_cls-8",
    width: 255.856,
    height: 194.113,
    rx: 10.758
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    className: "ib_cls-8",
    width: 255.856,
    height: 194.113,
    rx: 10.758
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(8.558 8.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    className: "ib_cls-13",
    d: "M6.335,0h226.07a6.335,6.335,0,0,1,6.335,6.335V170.662A6.335,6.335,0,0,1,232.405,177H6.336A6.336,6.336,0,0,1,0,170.662V6.335A6.335,6.335,0,0,1,6.335,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(8.558 8.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    className: "ib_cls-2",
    d: "M6.335,0h226.07a6.335,6.335,0,0,1,6.335,6.335V170.662A6.335,6.335,0,0,1,232.405,177H6.336A6.336,6.336,0,0,1,0,170.662V6.335A6.335,6.335,0,0,1,6.335,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    className: "ib_cls-14",
    transform: "translate(8.558 8.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    className: "ib_cls-4",
    d: "M6.336,0h226.07a6.335,6.335,0,0,1,6.335,6.335V170.662A6.336,6.336,0,0,1,232.4,177H6.336A6.336,6.336,0,0,1,0,170.662V6.336A6.336,6.336,0,0,1,6.336,0Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    className: "ib_cls-15",
    transform: "translate(60.73 227.559)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "ib_cls-4",
    d: "M649.972,297.227H527.3a5.859,5.859,0,0,1-5.859-5.859h0a5.859,5.859,0,0,1,5.859-5.86H649.972a5.86,5.86,0,0,1,5.86,5.86h0A5.86,5.86,0,0,1,649.972,297.227Z",
    transform: "translate(-521.436 -285.508)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(15.536 39.486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    className: "ib_cls-16",
    width: 109.436,
    height: 109.436,
    rx: 5.874
  }), /*#__PURE__*/React.createElement("path", {
    id: "increasing-arrow",
    "data-name": "Path 37",
    className: "ib_cls-13",
    d: "M562.057,140.987l1.4,4.045,6.506-2.245-20.051,27.9-12.387-7.8-12.83,18.925-12.359-.546L500.5,199.239a2.138,2.138,0,0,0,.611,2.963h0a2.139,2.139,0,0,0,2.964-.611l10.495-15.944,12.321.543,11.85-17.48,12.292,7.74,21.977-30.58v6.681h4.279V135.729Z",
    transform: "translate(-477.76 -108.116)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(117.347)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    className: "ib_cls-16",
    width: 109.436,
    height: 109.436,
    rx: 5.874
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(10.459 17.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "ib_cls-4",
    d: "M684.927,205.008H600.688a2.139,2.139,0,0,1-2.139-2.139V128.537a2.14,2.14,0,0,1,2.139-2.139h0a2.14,2.14,0,0,1,2.139,2.139v70.051a2.14,2.14,0,0,0,2.139,2.14h79.96a2.139,2.139,0,0,1,2.139,2.139h0A2.139,2.139,0,0,1,684.927,205.008Z",
    transform: "translate(-598.549 -126.398)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bar-1",
    "data-name": "Group 41",
    transform: "translate(12.686 75.34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    className: "ib_cls-13",
    width: 12.34,
    height: 18.746
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    className: "ib_cls-6",
    width: 12.34,
    height: 18.746
  })), /*#__PURE__*/React.createElement("g", {
    id: "bar-2",
    "data-name": "Group 42",
    transform: "translate(37.365 57.682)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    className: "ib_cls-13",
    width: 12.34,
    height: 36.405
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    className: "ib_cls-16",
    width: 12.34,
    height: 36.405
  })), /*#__PURE__*/React.createElement("g", {
    id: "bar-3",
    "data-name": "Group 43",
    transform: "translate(62.045 65.451)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    className: "ib_cls-13",
    width: 12.34,
    height: 28.635
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    className: "ib_cls-10",
    width: 12.34,
    height: 28.635
  })), /*#__PURE__*/React.createElement("rect", {
    id: "bar-4",
    "data-name": "Rectangle 29",
    className: "ib_cls-13",
    width: 12.34,
    height: 62.975,
    transform: "translate(86.725 31.112)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "ib_cls-8",
    d: "M432.006,495.7h0a5.273,5.273,0,0,1-5.273-5.273V392.789a5.273,5.273,0,0,1,5.273-5.273h0a5.273,5.273,0,0,1,5.272,5.273v97.637A5.273,5.273,0,0,1,432.006,495.7Z",
    transform: "translate(-111.254 -30.032)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Conveyor",
    transform: "translate(641.733 424.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Conveyor-2",
    "data-name": "Conveyor",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(0.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "ib_cls-18",
    d: "M1128.64,477.618h-396.7v-27.18h396.7a13.591,13.591,0,0,1,13.591,13.59h0A13.591,13.591,0,0,1,1128.64,477.618Z",
    transform: "translate(-731.942 -450.438)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(0 5.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "ib_cls-19",
    d: "M1128.64,455.512h-396.7v16.309h396.7a8.154,8.154,0,1,0,0-16.309Z",
    transform: "translate(-731.942 -455.512)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(40.635 9.513)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    className: "ib_cls-20",
    cx: 4.077,
    cy: 4.077,
    r: 4.077,
    transform: "translate(339.755)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    className: "ib_cls-20",
    cx: 4.077,
    cy: 4.077,
    r: 4.077,
    transform: "translate(271.804)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    className: "ib_cls-20",
    cx: 4.077,
    cy: 4.077,
    r: 4.077,
    transform: "translate(203.853)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    className: "ib_cls-20",
    cx: 4.077,
    cy: 4.077,
    r: 4.077,
    transform: "translate(135.902)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    className: "ib_cls-20",
    cx: 4.077,
    cy: 4.077,
    r: 4.077,
    transform: "translate(67.951)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    className: "ib_cls-20",
    cx: 4.077,
    cy: 4.077,
    r: 4.077
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(0 27.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(321.314 10.872)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    className: "ib_cls-21",
    width: 21.744,
    height: 10.872,
    transform: "translate(0 27.539)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    className: "ib_cls-18",
    width: 10.872,
    height: 27.539,
    transform: "translate(5.436)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(0.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "ib_cls-20",
    d: "M1125.82,486.681H731.942V475.809h399.314v5.436A5.435,5.435,0,0,1,1125.82,486.681Z",
    transform: "translate(-731.942 -475.809)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(129.56 10.872)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    className: "ib_cls-21",
    width: 21.744,
    height: 10.872,
    transform: "translate(0 27.539)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    className: "ib_cls-18",
    width: 10.872,
    height: 27.539,
    transform: "translate(5.436)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    className: "ib_cls-18",
    width: 328.406,
    height: 5.436,
    transform: "translate(0 26.197)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "cog",
    "data-name": "Group 100",
    transform: "translate(374.923 352.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(5.643 5.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "ib_cls-8",
    d: "M526.032,416.706a10.15,10.15,0,1,1-10.156-10.144A10.153,10.153,0,0,1,526.032,416.706Z",
    transform: "translate(-486.187 -386.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "ib_cls-4",
    d: "M526.032,416.706a10.15,10.15,0,1,1-10.156-10.144A10.153,10.153,0,0,1,526.032,416.706Z",
    transform: "translate(-486.187 -386.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "ib_cls-8",
    d: "M526.032,416.706a10.15,10.15,0,1,1-10.156-10.144A10.153,10.153,0,0,1,526.032,416.706Z",
    transform: "translate(-486.187 -386.443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "ib_cls-8",
    d: "M546.6,407.961l-5.4-9.345-18.765,10.834V387.782H511.648v21.667l-18.765-10.834-5.4,9.345,18.765,10.834-18.765,10.834,5.4,9.345,18.765-10.834v21.668h10.791V428.139L541.2,438.973l5.4-9.345-18.765-10.834Z",
    transform: "translate(-487.488 -387.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "ib_cls-39",
    d: "M546.6,407.961l-5.4-9.345-18.765,10.834V387.782H511.648v21.667l-18.765-10.834-5.4,9.345,18.765,10.834-18.765,10.834,5.4,9.345,18.765-10.834v21.668h10.791V428.139L541.2,438.973l5.4-9.345-18.765-10.834Z",
    transform: "translate(-487.488 -387.782)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "ib_cls-8",
    d: "M517.553,383.05A35.338,35.338,0,1,0,552.9,418.383,35.329,35.329,0,0,0,517.553,383.05Zm0,62.36a27.028,27.028,0,1,1,27.027-27.027A27.029,27.029,0,0,1,517.553,445.41Z",
    transform: "translate(-482.22 -383.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "ib_cls-9",
    d: "M517.553,383.05A35.338,35.338,0,1,0,552.9,418.383,35.329,35.329,0,0,0,517.553,383.05Zm0,62.36a27.028,27.028,0,1,1,27.027-27.027A27.029,27.029,0,0,1,517.553,445.41Z",
    transform: "translate(-482.22 -383.05)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "ib_cls-8",
    d: "M509.991,416.876a5.447,5.447,0,1,0,5.448-5.447A5.447,5.447,0,0,0,509.991,416.876Z",
    transform: "translate(-480.24 -381.026)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentBasket);
export default __webpack_public_path__ + "static/media/intelligentBasket.14f496ff35b5397cb85582b06f42854e.svg";
export { ForwardRef as ReactComponent };